//----------------------
// <auto-generated>
//     Generated using Aya Client Generator [Version 1.0.2]
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { SortDirectionEnum } from './enums/sort-direction-enum.enum';
import { API_BASE_URL } from './misc/api-base-url.token';
import { blobToText } from './misc/blob-to-text.function';
import { FileParameter } from './misc/file-parameter.model';
import { FileResponse } from './misc/file-response.model';
import { throwException } from './misc/throw-exception.function';
import { AyaLabCodeDto } from './models/aya-lab-code-dto.model';
import { CandidateRequiredLabDto } from './models/candidate-required-lab-dto.model';
import { CandidateVendorTestCodeDto } from './models/candidate-vendor-test-code-dto.model';
import { ComplianceLabRequestCommentDto } from './models/compliance-lab-request-comment-dto.model';
import { ComplianceLabRequestDocumentTypeConfigurationDto } from './models/compliance-lab-request-document-type-configuration-dto.model';
import { ComplianceLabRequestVendorDto } from './models/compliance-lab-request-vendor-dto.model';
import { ComplianceRequestCandidateContractsDto } from './models/compliance-request-candidate-contracts-dto.model';
import { ComplianceRequestCreateUpdateDto } from './models/compliance-request-create-update-dto.model';
import { ComplianceRequestDetailBaseDto } from './models/compliance-request-detail-base-dto.model';
import { ComplianceRequestRTCRDto } from './models/compliance-request-rtcrdto.model';
import { ComplianceUserMentionsDto } from './models/compliance-user-mentions-dto.model';
import { DocumentTypeSelectionDto } from './models/document-type-selection-dto.model';
import { FetchArguments2OfDsAdminFilter } from './models/fetch-arguments2of-ds-admin-filter.model';
import { KeyValueDto } from './models/key-value-dto.model';
import { LabOrderChangesNoteDetailsDto } from './models/lab-order-changes-note-details-dto.model';
import { LabOrderSelectionDto } from './models/lab-order-selection-dto.model';
import { LabOrderTicketHDSAssignmentsForContractDto } from './models/lab-order-ticket-hdsassignments-for-contract-dto.model';
import { PagingTokenOfAyaLabCodeDto } from './models/paging-token-of-aya-lab-code-dto.model';
import { PagingTokenOfComplianceDocumentDto } from './models/paging-token-of-compliance-document-dto.model';
import { PagingTokenOfComplianceRequestGridItemDto } from './models/paging-token-of-compliance-request-grid-item-dto.model';
import { RequestBulkStatusUpdateDto } from './models/request-bulk-status-update-dto.model';
import { UsersSecurityGroupsDto } from './models/users-security-groups-dto.model';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class ComplianceRequestsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    search(filter_Id: number | null | undefined, filter_TicketTypes: number[] | null | undefined, filter_Statuses: number[] | null | undefined, filter_TicketProgressStatuses: number[] | null | undefined, filter_Candidate: string | null | undefined, filter_AssignedToIds: number[] | null | undefined, filter_ContractFacilityName: string | null | undefined, filter_CreatedBy: string | null | undefined, filter_DocDueDateFrom: Date | null | undefined, filter_DocDueDateTo: Date | null | undefined, filter_CreatedOnFrom: Date | null | undefined, filter_CreatedOnTo: Date | null | undefined, filter_TicketPriorities: string[] | null | undefined, filter_ContractStatuses: string[] | null | undefined, filter_ContractStartDateFrom: Date | null | undefined, filter_ContractStartDateTo: Date | null | undefined, pageSize: number | undefined, skip: number | undefined, sort_Field: string | null | undefined, sort_Type: SortDirectionEnum | undefined, paginated: boolean | undefined): Observable<PagingTokenOfComplianceRequestGridItemDto> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/search?";
        if (filter_Id !== undefined && filter_Id !== null)
            url_ += "Filter.Id=" + encodeURIComponent("" + filter_Id) + "&";
        if (filter_TicketTypes !== undefined && filter_TicketTypes !== null)
            filter_TicketTypes && filter_TicketTypes.forEach(item => { url_ += "Filter.TicketTypes=" + encodeURIComponent("" + item) + "&"; });
        if (filter_Statuses !== undefined && filter_Statuses !== null)
            filter_Statuses && filter_Statuses.forEach(item => { url_ += "Filter.Statuses=" + encodeURIComponent("" + item) + "&"; });
        if (filter_TicketProgressStatuses !== undefined && filter_TicketProgressStatuses !== null)
            filter_TicketProgressStatuses && filter_TicketProgressStatuses.forEach(item => { url_ += "Filter.TicketProgressStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (filter_Candidate !== undefined && filter_Candidate !== null)
            url_ += "Filter.Candidate=" + encodeURIComponent("" + filter_Candidate) + "&";
        if (filter_AssignedToIds !== undefined && filter_AssignedToIds !== null)
            filter_AssignedToIds && filter_AssignedToIds.forEach(item => { url_ += "Filter.AssignedToIds=" + encodeURIComponent("" + item) + "&"; });
        if (filter_ContractFacilityName !== undefined && filter_ContractFacilityName !== null)
            url_ += "Filter.ContractFacilityName=" + encodeURIComponent("" + filter_ContractFacilityName) + "&";
        if (filter_CreatedBy !== undefined && filter_CreatedBy !== null)
            url_ += "Filter.CreatedBy=" + encodeURIComponent("" + filter_CreatedBy) + "&";
        if (filter_DocDueDateFrom !== undefined && filter_DocDueDateFrom !== null)
            url_ += "Filter.DocDueDateFrom=" + encodeURIComponent(filter_DocDueDateFrom ? "" + filter_DocDueDateFrom.toISOString() : "") + "&";
        if (filter_DocDueDateTo !== undefined && filter_DocDueDateTo !== null)
            url_ += "Filter.DocDueDateTo=" + encodeURIComponent(filter_DocDueDateTo ? "" + filter_DocDueDateTo.toISOString() : "") + "&";
        if (filter_CreatedOnFrom !== undefined && filter_CreatedOnFrom !== null)
            url_ += "Filter.CreatedOnFrom=" + encodeURIComponent(filter_CreatedOnFrom ? "" + filter_CreatedOnFrom.toISOString() : "") + "&";
        if (filter_CreatedOnTo !== undefined && filter_CreatedOnTo !== null)
            url_ += "Filter.CreatedOnTo=" + encodeURIComponent(filter_CreatedOnTo ? "" + filter_CreatedOnTo.toISOString() : "") + "&";
        if (filter_TicketPriorities !== undefined && filter_TicketPriorities !== null)
            filter_TicketPriorities && filter_TicketPriorities.forEach(item => { url_ += "Filter.TicketPriorities=" + encodeURIComponent("" + item) + "&"; });
        if (filter_ContractStatuses !== undefined && filter_ContractStatuses !== null)
            filter_ContractStatuses && filter_ContractStatuses.forEach(item => { url_ += "Filter.ContractStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (filter_ContractStartDateFrom !== undefined && filter_ContractStartDateFrom !== null)
            url_ += "Filter.ContractStartDateFrom=" + encodeURIComponent(filter_ContractStartDateFrom ? "" + filter_ContractStartDateFrom.toISOString() : "") + "&";
        if (filter_ContractStartDateTo !== undefined && filter_ContractStartDateTo !== null)
            url_ += "Filter.ContractStartDateTo=" + encodeURIComponent(filter_ContractStartDateTo ? "" + filter_ContractStartDateTo.toISOString() : "") + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (sort_Field !== undefined && sort_Field !== null)
            url_ += "Sort.Field=" + encodeURIComponent("" + sort_Field) + "&";
        if (sort_Type === null)
            throw new Error("The parameter 'sort_Type' cannot be null.");
        else if (sort_Type !== undefined)
            url_ += "Sort.Type=" + encodeURIComponent("" + sort_Type) + "&";
        if (paginated === null)
            throw new Error("The parameter 'paginated' cannot be null.");
        else if (paginated !== undefined)
            url_ += "Paginated=" + encodeURIComponent("" + paginated) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingTokenOfComplianceRequestGridItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingTokenOfComplianceRequestGridItemDto>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PagingTokenOfComplianceRequestGridItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingTokenOfComplianceRequestGridItemDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchLabTicketRequests(filter_Id: number | null | undefined, filter_TicketTypes: number[] | null | undefined, filter_Statuses: number[] | null | undefined, filter_TicketProgressStatuses: number[] | null | undefined, filter_Candidate: string | null | undefined, filter_AssignedToIds: number[] | null | undefined, filter_ContractFacilityName: string | null | undefined, filter_CreatedBy: string | null | undefined, filter_DocDueDateFrom: Date | null | undefined, filter_DocDueDateTo: Date | null | undefined, filter_CreatedOnFrom: Date | null | undefined, filter_CreatedOnTo: Date | null | undefined, filter_TicketPriorities: string[] | null | undefined, filter_ContractStatuses: string[] | null | undefined, filter_ContractStartDateFrom: Date | null | undefined, filter_ContractStartDateTo: Date | null | undefined, pageSize: number | undefined, skip: number | undefined, sort_Field: string | null | undefined, sort_Type: SortDirectionEnum | undefined, paginated: boolean | undefined): Observable<PagingTokenOfComplianceRequestGridItemDto> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/search-lab-ticket-requests?";
        if (filter_Id !== undefined && filter_Id !== null)
            url_ += "Filter.Id=" + encodeURIComponent("" + filter_Id) + "&";
        if (filter_TicketTypes !== undefined && filter_TicketTypes !== null)
            filter_TicketTypes && filter_TicketTypes.forEach(item => { url_ += "Filter.TicketTypes=" + encodeURIComponent("" + item) + "&"; });
        if (filter_Statuses !== undefined && filter_Statuses !== null)
            filter_Statuses && filter_Statuses.forEach(item => { url_ += "Filter.Statuses=" + encodeURIComponent("" + item) + "&"; });
        if (filter_TicketProgressStatuses !== undefined && filter_TicketProgressStatuses !== null)
            filter_TicketProgressStatuses && filter_TicketProgressStatuses.forEach(item => { url_ += "Filter.TicketProgressStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (filter_Candidate !== undefined && filter_Candidate !== null)
            url_ += "Filter.Candidate=" + encodeURIComponent("" + filter_Candidate) + "&";
        if (filter_AssignedToIds !== undefined && filter_AssignedToIds !== null)
            filter_AssignedToIds && filter_AssignedToIds.forEach(item => { url_ += "Filter.AssignedToIds=" + encodeURIComponent("" + item) + "&"; });
        if (filter_ContractFacilityName !== undefined && filter_ContractFacilityName !== null)
            url_ += "Filter.ContractFacilityName=" + encodeURIComponent("" + filter_ContractFacilityName) + "&";
        if (filter_CreatedBy !== undefined && filter_CreatedBy !== null)
            url_ += "Filter.CreatedBy=" + encodeURIComponent("" + filter_CreatedBy) + "&";
        if (filter_DocDueDateFrom !== undefined && filter_DocDueDateFrom !== null)
            url_ += "Filter.DocDueDateFrom=" + encodeURIComponent(filter_DocDueDateFrom ? "" + filter_DocDueDateFrom.toISOString() : "") + "&";
        if (filter_DocDueDateTo !== undefined && filter_DocDueDateTo !== null)
            url_ += "Filter.DocDueDateTo=" + encodeURIComponent(filter_DocDueDateTo ? "" + filter_DocDueDateTo.toISOString() : "") + "&";
        if (filter_CreatedOnFrom !== undefined && filter_CreatedOnFrom !== null)
            url_ += "Filter.CreatedOnFrom=" + encodeURIComponent(filter_CreatedOnFrom ? "" + filter_CreatedOnFrom.toISOString() : "") + "&";
        if (filter_CreatedOnTo !== undefined && filter_CreatedOnTo !== null)
            url_ += "Filter.CreatedOnTo=" + encodeURIComponent(filter_CreatedOnTo ? "" + filter_CreatedOnTo.toISOString() : "") + "&";
        if (filter_TicketPriorities !== undefined && filter_TicketPriorities !== null)
            filter_TicketPriorities && filter_TicketPriorities.forEach(item => { url_ += "Filter.TicketPriorities=" + encodeURIComponent("" + item) + "&"; });
        if (filter_ContractStatuses !== undefined && filter_ContractStatuses !== null)
            filter_ContractStatuses && filter_ContractStatuses.forEach(item => { url_ += "Filter.ContractStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (filter_ContractStartDateFrom !== undefined && filter_ContractStartDateFrom !== null)
            url_ += "Filter.ContractStartDateFrom=" + encodeURIComponent(filter_ContractStartDateFrom ? "" + filter_ContractStartDateFrom.toISOString() : "") + "&";
        if (filter_ContractStartDateTo !== undefined && filter_ContractStartDateTo !== null)
            url_ += "Filter.ContractStartDateTo=" + encodeURIComponent(filter_ContractStartDateTo ? "" + filter_ContractStartDateTo.toISOString() : "") + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (sort_Field !== undefined && sort_Field !== null)
            url_ += "Sort.Field=" + encodeURIComponent("" + sort_Field) + "&";
        if (sort_Type === null)
            throw new Error("The parameter 'sort_Type' cannot be null.");
        else if (sort_Type !== undefined)
            url_ += "Sort.Type=" + encodeURIComponent("" + sort_Type) + "&";
        if (paginated === null)
            throw new Error("The parameter 'paginated' cannot be null.");
        else if (paginated !== undefined)
            url_ += "Paginated=" + encodeURIComponent("" + paginated) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchLabTicketRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchLabTicketRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingTokenOfComplianceRequestGridItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingTokenOfComplianceRequestGridItemDto>;
        }));
    }

    protected processSearchLabTicketRequests(response: HttpResponseBase): Observable<PagingTokenOfComplianceRequestGridItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingTokenOfComplianceRequestGridItemDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchComplianceTicketRequests(filter_Id: number | null | undefined, filter_TicketTypes: number[] | null | undefined, filter_Statuses: number[] | null | undefined, filter_TicketProgressStatuses: number[] | null | undefined, filter_Candidate: string | null | undefined, filter_AssignedToIds: number[] | null | undefined, filter_ContractFacilityName: string | null | undefined, filter_CreatedBy: string | null | undefined, filter_DocDueDateFrom: Date | null | undefined, filter_DocDueDateTo: Date | null | undefined, filter_CreatedOnFrom: Date | null | undefined, filter_CreatedOnTo: Date | null | undefined, filter_TicketPriorities: string[] | null | undefined, filter_ContractStatuses: string[] | null | undefined, filter_ContractStartDateFrom: Date | null | undefined, filter_ContractStartDateTo: Date | null | undefined, pageSize: number | undefined, skip: number | undefined, sort_Field: string | null | undefined, sort_Type: SortDirectionEnum | undefined, paginated: boolean | undefined): Observable<PagingTokenOfComplianceRequestGridItemDto> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/search-compliance-ticket-requests?";
        if (filter_Id !== undefined && filter_Id !== null)
            url_ += "Filter.Id=" + encodeURIComponent("" + filter_Id) + "&";
        if (filter_TicketTypes !== undefined && filter_TicketTypes !== null)
            filter_TicketTypes && filter_TicketTypes.forEach(item => { url_ += "Filter.TicketTypes=" + encodeURIComponent("" + item) + "&"; });
        if (filter_Statuses !== undefined && filter_Statuses !== null)
            filter_Statuses && filter_Statuses.forEach(item => { url_ += "Filter.Statuses=" + encodeURIComponent("" + item) + "&"; });
        if (filter_TicketProgressStatuses !== undefined && filter_TicketProgressStatuses !== null)
            filter_TicketProgressStatuses && filter_TicketProgressStatuses.forEach(item => { url_ += "Filter.TicketProgressStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (filter_Candidate !== undefined && filter_Candidate !== null)
            url_ += "Filter.Candidate=" + encodeURIComponent("" + filter_Candidate) + "&";
        if (filter_AssignedToIds !== undefined && filter_AssignedToIds !== null)
            filter_AssignedToIds && filter_AssignedToIds.forEach(item => { url_ += "Filter.AssignedToIds=" + encodeURIComponent("" + item) + "&"; });
        if (filter_ContractFacilityName !== undefined && filter_ContractFacilityName !== null)
            url_ += "Filter.ContractFacilityName=" + encodeURIComponent("" + filter_ContractFacilityName) + "&";
        if (filter_CreatedBy !== undefined && filter_CreatedBy !== null)
            url_ += "Filter.CreatedBy=" + encodeURIComponent("" + filter_CreatedBy) + "&";
        if (filter_DocDueDateFrom !== undefined && filter_DocDueDateFrom !== null)
            url_ += "Filter.DocDueDateFrom=" + encodeURIComponent(filter_DocDueDateFrom ? "" + filter_DocDueDateFrom.toISOString() : "") + "&";
        if (filter_DocDueDateTo !== undefined && filter_DocDueDateTo !== null)
            url_ += "Filter.DocDueDateTo=" + encodeURIComponent(filter_DocDueDateTo ? "" + filter_DocDueDateTo.toISOString() : "") + "&";
        if (filter_CreatedOnFrom !== undefined && filter_CreatedOnFrom !== null)
            url_ += "Filter.CreatedOnFrom=" + encodeURIComponent(filter_CreatedOnFrom ? "" + filter_CreatedOnFrom.toISOString() : "") + "&";
        if (filter_CreatedOnTo !== undefined && filter_CreatedOnTo !== null)
            url_ += "Filter.CreatedOnTo=" + encodeURIComponent(filter_CreatedOnTo ? "" + filter_CreatedOnTo.toISOString() : "") + "&";
        if (filter_TicketPriorities !== undefined && filter_TicketPriorities !== null)
            filter_TicketPriorities && filter_TicketPriorities.forEach(item => { url_ += "Filter.TicketPriorities=" + encodeURIComponent("" + item) + "&"; });
        if (filter_ContractStatuses !== undefined && filter_ContractStatuses !== null)
            filter_ContractStatuses && filter_ContractStatuses.forEach(item => { url_ += "Filter.ContractStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (filter_ContractStartDateFrom !== undefined && filter_ContractStartDateFrom !== null)
            url_ += "Filter.ContractStartDateFrom=" + encodeURIComponent(filter_ContractStartDateFrom ? "" + filter_ContractStartDateFrom.toISOString() : "") + "&";
        if (filter_ContractStartDateTo !== undefined && filter_ContractStartDateTo !== null)
            url_ += "Filter.ContractStartDateTo=" + encodeURIComponent(filter_ContractStartDateTo ? "" + filter_ContractStartDateTo.toISOString() : "") + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (sort_Field !== undefined && sort_Field !== null)
            url_ += "Sort.Field=" + encodeURIComponent("" + sort_Field) + "&";
        if (sort_Type === null)
            throw new Error("The parameter 'sort_Type' cannot be null.");
        else if (sort_Type !== undefined)
            url_ += "Sort.Type=" + encodeURIComponent("" + sort_Type) + "&";
        if (paginated === null)
            throw new Error("The parameter 'paginated' cannot be null.");
        else if (paginated !== undefined)
            url_ += "Paginated=" + encodeURIComponent("" + paginated) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchComplianceTicketRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchComplianceTicketRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingTokenOfComplianceRequestGridItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingTokenOfComplianceRequestGridItemDto>;
        }));
    }

    protected processSearchComplianceTicketRequests(response: HttpResponseBase): Observable<PagingTokenOfComplianceRequestGridItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingTokenOfComplianceRequestGridItemDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLabOrderTicketHDSAssignmentsByContractId(contractId: number): Observable<LabOrderTicketHDSAssignmentsForContractDto[]> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/hds-assignments/{contractId}";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLabOrderTicketHDSAssignmentsByContractId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLabOrderTicketHDSAssignmentsByContractId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LabOrderTicketHDSAssignmentsForContractDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LabOrderTicketHDSAssignmentsForContractDto[]>;
        }));
    }

    protected processGetLabOrderTicketHDSAssignmentsByContractId(response: HttpResponseBase): Observable<LabOrderTicketHDSAssignmentsForContractDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LabOrderTicketHDSAssignmentsForContractDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCandidateRequiredLabs(candidateId: number): Observable<CandidateRequiredLabDto[]> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/required-labs/{candidateId}";
        if (candidateId === undefined || candidateId === null)
            throw new Error("The parameter 'candidateId' must be defined.");
        url_ = url_.replace("{candidateId}", encodeURIComponent("" + candidateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidateRequiredLabs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidateRequiredLabs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidateRequiredLabDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidateRequiredLabDto[]>;
        }));
    }

    protected processGetCandidateRequiredLabs(response: HttpResponseBase): Observable<CandidateRequiredLabDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CandidateRequiredLabDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLabOrderRequiredLabs(labOrderTicketId: number): Observable<CandidateRequiredLabDto[]> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/required-labs/lab-request/{labOrderTicketId}";
        if (labOrderTicketId === undefined || labOrderTicketId === null)
            throw new Error("The parameter 'labOrderTicketId' must be defined.");
        url_ = url_.replace("{labOrderTicketId}", encodeURIComponent("" + labOrderTicketId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLabOrderRequiredLabs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLabOrderRequiredLabs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidateRequiredLabDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidateRequiredLabDto[]>;
        }));
    }

    protected processGetLabOrderRequiredLabs(response: HttpResponseBase): Observable<CandidateRequiredLabDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CandidateRequiredLabDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLabOrderSelections(ticketId: number): Observable<LabOrderSelectionDto[]> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/required-labs/selections/{ticketId}";
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLabOrderSelections(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLabOrderSelections(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LabOrderSelectionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LabOrderSelectionDto[]>;
        }));
    }

    protected processGetLabOrderSelections(response: HttpResponseBase): Observable<LabOrderSelectionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LabOrderSelectionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getNotMappedLabOrderReportItems(ticketId: number): Observable<string[]> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/required-labs/not-mapped-report-items/{ticketId}";
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotMappedLabOrderReportItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotMappedLabOrderReportItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetNotMappedLabOrderReportItems(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDocumentTypeSelections(): Observable<DocumentTypeSelectionDto[]> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/required-labs/selections";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentTypeSelections(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentTypeSelections(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentTypeSelectionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentTypeSelectionDto[]>;
        }));
    }

    protected processGetDocumentTypeSelections(response: HttpResponseBase): Observable<DocumentTypeSelectionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentTypeSelectionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByContractId(contractId: number): Observable<ComplianceRequestRTCRDto[]> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/contract/{contractId}";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByContractId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByContractId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComplianceRequestRTCRDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComplianceRequestRTCRDto[]>;
        }));
    }

    protected processGetByContractId(response: HttpResponseBase): Observable<ComplianceRequestRTCRDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComplianceRequestRTCRDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchCandidateContracts(name: string): Observable<ComplianceRequestCandidateContractsDto[]> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/candidate/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchCandidateContracts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchCandidateContracts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComplianceRequestCandidateContractsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComplianceRequestCandidateContractsDto[]>;
        }));
    }

    protected processSearchCandidateContracts(response: HttpResponseBase): Observable<ComplianceRequestCandidateContractsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComplianceRequestCandidateContractsDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getComplianceRequestDetail(id: number): Observable<ComplianceRequestDetailBaseDto> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetComplianceRequestDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetComplianceRequestDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComplianceRequestDetailBaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComplianceRequestDetailBaseDto>;
        }));
    }

    protected processGetComplianceRequestDetail(response: HttpResponseBase): Observable<ComplianceRequestDetailBaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComplianceRequestDetailBaseDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateComplianceRequest(id: number, dto: ComplianceRequestCreateUpdateDto): Observable<void> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateComplianceRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateComplianceRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateComplianceRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getComplianceRequestComments(id: number): Observable<ComplianceLabRequestCommentDto[]> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/{id}/comments";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetComplianceRequestComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetComplianceRequestComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComplianceLabRequestCommentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComplianceLabRequestCommentDto[]>;
        }));
    }

    protected processGetComplianceRequestComments(response: HttpResponseBase): Observable<ComplianceLabRequestCommentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComplianceLabRequestCommentDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createComplianceRequest(dto: ComplianceRequestCreateUpdateDto): Observable<number> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateComplianceRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateComplianceRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateComplianceRequest(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createScreening(id: number): Observable<void> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/{id}/screening";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateScreening(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateScreening(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateScreening(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addComplianceLabRequestComment(id: number, comment: string): Observable<ComplianceLabRequestCommentDto> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/{id}/comment";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(comment);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddComplianceLabRequestComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddComplianceLabRequestComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComplianceLabRequestCommentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComplianceLabRequestCommentDto>;
        }));
    }

    protected processAddComplianceLabRequestComment(response: HttpResponseBase): Observable<ComplianceLabRequestCommentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComplianceLabRequestCommentDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addComplianceLabRequestCommentWithUserMentions(comment: ComplianceUserMentionsDto): Observable<ComplianceLabRequestCommentDto> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/comment-user-mentions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(comment);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddComplianceLabRequestCommentWithUserMentions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddComplianceLabRequestCommentWithUserMentions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComplianceLabRequestCommentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComplianceLabRequestCommentDto>;
        }));
    }

    protected processAddComplianceLabRequestCommentWithUserMentions(response: HttpResponseBase): Observable<ComplianceLabRequestCommentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComplianceLabRequestCommentDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getComplianceRequestAssignees(name: string | null | undefined): Observable<KeyValueDto[]> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/Assignees?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetComplianceRequestAssignees(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetComplianceRequestAssignees(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueDto[]>;
        }));
    }

    protected processGetComplianceRequestAssignees(response: HttpResponseBase): Observable<KeyValueDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KeyValueDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getComplianceRequestAssigneesFilter(): Observable<KeyValueDto[]> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/assignees-filter";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetComplianceRequestAssigneesFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetComplianceRequestAssigneesFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueDto[]>;
        }));
    }

    protected processGetComplianceRequestAssigneesFilter(response: HttpResponseBase): Observable<KeyValueDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KeyValueDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getComplianceRequestCategories(): Observable<KeyValueDto[]> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/Categories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetComplianceRequestCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetComplianceRequestCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueDto[]>;
        }));
    }

    protected processGetComplianceRequestCategories(response: HttpResponseBase): Observable<KeyValueDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KeyValueDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getComplianceRequestCertificates(): Observable<KeyValueDto[]> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/Certificates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetComplianceRequestCertificates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetComplianceRequestCertificates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueDto[]>;
        }));
    }

    protected processGetComplianceRequestCertificates(response: HttpResponseBase): Observable<KeyValueDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KeyValueDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    uploadDocuments(complianceRequestId: number, shippingRequestId: number | null | undefined, healthRequestId: number | null | undefined, vendorId: number | null | undefined, requestId: number | undefined, title: string | null | undefined, file: FileParameter | null | undefined, originalFileName: string | null | undefined, recipeForSuccess: boolean | undefined, path: string | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/{complianceRequestId}/documents";
        if (complianceRequestId === undefined || complianceRequestId === null)
            throw new Error("The parameter 'complianceRequestId' must be defined.");
        url_ = url_.replace("{complianceRequestId}", encodeURIComponent("" + complianceRequestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (shippingRequestId !== null && shippingRequestId !== undefined)
            content_.append("ShippingRequestId", shippingRequestId.toString());
        if (healthRequestId !== null && healthRequestId !== undefined)
            content_.append("HealthRequestId", healthRequestId.toString());
        if (vendorId !== null && vendorId !== undefined)
            content_.append("VendorId", vendorId.toString());
        if (requestId === null || requestId === undefined)
            throw new Error("The parameter 'requestId' cannot be null.");
        else
            content_.append("RequestId", requestId.toString());
        if (title !== null && title !== undefined)
            content_.append("Title", title.toString());
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        if (originalFileName !== null && originalFileName !== undefined)
            content_.append("OriginalFileName", originalFileName.toString());
        if (recipeForSuccess === null || recipeForSuccess === undefined)
            throw new Error("The parameter 'recipeForSuccess' cannot be null.");
        else
            content_.append("RecipeForSuccess", recipeForSuccess.toString());
        if (path !== null && path !== undefined)
            content_.append("Path", path.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUploadDocuments(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDocuments(complianceRequestId: number, filter_UserId: number | undefined, filter_Name: string | null | undefined, filter_Path: string | null | undefined, filter_UploadedDate: Date | undefined, filter_UploadedBy: string | null | undefined, filter_Title: string | null | undefined, filter_ShippingRequestId: number | null | undefined, filter_HealthRequestId: number | null | undefined, pageSize: number | undefined, skip: number | undefined, sort_Field: string | null | undefined, sort_Type: SortDirectionEnum | undefined, paginated: boolean | undefined): Observable<PagingTokenOfComplianceDocumentDto> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/{complianceRequestId}/documents?";
        if (complianceRequestId === undefined || complianceRequestId === null)
            throw new Error("The parameter 'complianceRequestId' must be defined.");
        url_ = url_.replace("{complianceRequestId}", encodeURIComponent("" + complianceRequestId));
        if (filter_UserId === null)
            throw new Error("The parameter 'filter_UserId' cannot be null.");
        else if (filter_UserId !== undefined)
            url_ += "Filter.UserId=" + encodeURIComponent("" + filter_UserId) + "&";
        if (filter_Name !== undefined && filter_Name !== null)
            url_ += "Filter.Name=" + encodeURIComponent("" + filter_Name) + "&";
        if (filter_Path !== undefined && filter_Path !== null)
            url_ += "Filter.Path=" + encodeURIComponent("" + filter_Path) + "&";
        if (filter_UploadedDate === null)
            throw new Error("The parameter 'filter_UploadedDate' cannot be null.");
        else if (filter_UploadedDate !== undefined)
            url_ += "Filter.UploadedDate=" + encodeURIComponent(filter_UploadedDate ? "" + filter_UploadedDate.toISOString() : "") + "&";
        if (filter_UploadedBy !== undefined && filter_UploadedBy !== null)
            url_ += "Filter.UploadedBy=" + encodeURIComponent("" + filter_UploadedBy) + "&";
        if (filter_Title !== undefined && filter_Title !== null)
            url_ += "Filter.Title=" + encodeURIComponent("" + filter_Title) + "&";
        if (filter_ShippingRequestId !== undefined && filter_ShippingRequestId !== null)
            url_ += "Filter.ShippingRequestId=" + encodeURIComponent("" + filter_ShippingRequestId) + "&";
        if (filter_HealthRequestId !== undefined && filter_HealthRequestId !== null)
            url_ += "Filter.HealthRequestId=" + encodeURIComponent("" + filter_HealthRequestId) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (sort_Field !== undefined && sort_Field !== null)
            url_ += "Sort.Field=" + encodeURIComponent("" + sort_Field) + "&";
        if (sort_Type === null)
            throw new Error("The parameter 'sort_Type' cannot be null.");
        else if (sort_Type !== undefined)
            url_ += "Sort.Type=" + encodeURIComponent("" + sort_Type) + "&";
        if (paginated === null)
            throw new Error("The parameter 'paginated' cannot be null.");
        else if (paginated !== undefined)
            url_ += "Paginated=" + encodeURIComponent("" + paginated) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingTokenOfComplianceDocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingTokenOfComplianceDocumentDto>;
        }));
    }

    protected processGetDocuments(response: HttpResponseBase): Observable<PagingTokenOfComplianceDocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingTokenOfComplianceDocumentDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadFile(complianceRequestId: number, documentId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/{complianceRequestId}/documents/{documentId}";
        if (complianceRequestId === undefined || complianceRequestId === null)
            throw new Error("The parameter 'complianceRequestId' must be defined.");
        url_ = url_.replace("{complianceRequestId}", encodeURIComponent("" + complianceRequestId));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeDocument(complianceRequestId: number, documentId: number): Observable<number> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/{complianceRequestId}/documents/{documentId}";
        if (complianceRequestId === undefined || complianceRequestId === null)
            throw new Error("The parameter 'complianceRequestId' must be defined.");
        url_ = url_.replace("{complianceRequestId}", encodeURIComponent("" + complianceRequestId));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processRemoveDocument(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkStatusUpdate(dto: RequestBulkStatusUpdateDto): Observable<void> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/bulk-status-update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkStatusUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkStatusUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkStatusUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDsAdminCodes(args: FetchArguments2OfDsAdminFilter): Observable<PagingTokenOfAyaLabCodeDto> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/ds-admin-codes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDsAdminCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDsAdminCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingTokenOfAyaLabCodeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingTokenOfAyaLabCodeDto>;
        }));
    }

    protected processGetDsAdminCodes(response: HttpResponseBase): Observable<PagingTokenOfAyaLabCodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingTokenOfAyaLabCodeDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    dsIsExist(code: AyaLabCodeDto): Observable<AyaLabCodeDto> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/ds-is-exist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(code);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDsIsExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDsIsExist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AyaLabCodeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AyaLabCodeDto>;
        }));
    }

    protected processDsIsExist(response: HttpResponseBase): Observable<AyaLabCodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AyaLabCodeDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addAyaCode(code: AyaLabCodeDto): Observable<void> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/add-ds-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(code);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAyaCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAyaCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddAyaCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAyaCode(code: AyaLabCodeDto): Observable<void> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/update-ds-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(code);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAyaCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAyaCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAyaCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAyaLabCodes(codeGroup: string): Observable<AyaLabCodeDto[]> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/aya-lab-codes/{codeGroup}";
        if (codeGroup === undefined || codeGroup === null)
            throw new Error("The parameter 'codeGroup' must be defined.");
        url_ = url_.replace("{codeGroup}", encodeURIComponent("" + codeGroup));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAyaLabCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAyaLabCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AyaLabCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AyaLabCodeDto[]>;
        }));
    }

    protected processGetAyaLabCodes(response: HttpResponseBase): Observable<AyaLabCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AyaLabCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLabOrderChangesNoteDetails(labOrderTicketReportItemId: number, createdDate: Date | null | undefined): Observable<LabOrderChangesNoteDetailsDto> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/lab-order-ticket-report-items/{labOrderTicketReportItemId}/details?";
        if (labOrderTicketReportItemId === undefined || labOrderTicketReportItemId === null)
            throw new Error("The parameter 'labOrderTicketReportItemId' must be defined.");
        url_ = url_.replace("{labOrderTicketReportItemId}", encodeURIComponent("" + labOrderTicketReportItemId));
        if (createdDate !== undefined && createdDate !== null)
            url_ += "createdDate=" + encodeURIComponent(createdDate ? "" + createdDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLabOrderChangesNoteDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLabOrderChangesNoteDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LabOrderChangesNoteDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LabOrderChangesNoteDetailsDto>;
        }));
    }

    protected processGetLabOrderChangesNoteDetails(response: HttpResponseBase): Observable<LabOrderChangesNoteDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LabOrderChangesNoteDetailsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMostUsedAyaCodeForFacility(contractId: number | undefined): Observable<number | null> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/most-used-aya-code?";
        if (contractId === null)
            throw new Error("The parameter 'contractId' cannot be null.");
        else if (contractId !== undefined)
            url_ += "contractId=" + encodeURIComponent("" + contractId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMostUsedAyaCodeForFacility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMostUsedAyaCodeForFacility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number | null>;
        }));
    }

    protected processGetMostUsedAyaCodeForFacility(response: HttpResponseBase): Observable<number | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUsersSecurityGroups(count: number, userName: string): Observable<UsersSecurityGroupsDto[]> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/users-security-groups/{count}/{userName}";
        if (count === undefined || count === null)
            throw new Error("The parameter 'count' must be defined.");
        url_ = url_.replace("{count}", encodeURIComponent("" + count));
        if (userName === undefined || userName === null)
            throw new Error("The parameter 'userName' must be defined.");
        url_ = url_.replace("{userName}", encodeURIComponent("" + userName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersSecurityGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersSecurityGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UsersSecurityGroupsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UsersSecurityGroupsDto[]>;
        }));
    }

    protected processGetUsersSecurityGroups(response: HttpResponseBase): Observable<UsersSecurityGroupsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UsersSecurityGroupsDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLabRequestVendors(): Observable<ComplianceLabRequestVendorDto[]> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/lab-request-vendors";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLabRequestVendors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLabRequestVendors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComplianceLabRequestVendorDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComplianceLabRequestVendorDto[]>;
        }));
    }

    protected processGetLabRequestVendors(response: HttpResponseBase): Observable<ComplianceLabRequestVendorDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComplianceLabRequestVendorDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDsHasConfiguration(documentTypeLevel: number, entityId: number): Observable<number[]> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/ds-has-configuration/{documentTypeLevel}/{entityId}";
        if (documentTypeLevel === undefined || documentTypeLevel === null)
            throw new Error("The parameter 'documentTypeLevel' must be defined.");
        url_ = url_.replace("{documentTypeLevel}", encodeURIComponent("" + documentTypeLevel));
        if (entityId === undefined || entityId === null)
            throw new Error("The parameter 'entityId' must be defined.");
        url_ = url_.replace("{entityId}", encodeURIComponent("" + entityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDsHasConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDsHasConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetDsHasConfiguration(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLabRequestDocumentTypeConfiguration(documentTypeId: number, documentTypeLevelType: number, levelId: number): Observable<ComplianceLabRequestDocumentTypeConfigurationDto> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/lab-request-document-type-configuration/{documentTypeId}/{documentTypeLevelType}/{levelId}";
        if (documentTypeId === undefined || documentTypeId === null)
            throw new Error("The parameter 'documentTypeId' must be defined.");
        url_ = url_.replace("{documentTypeId}", encodeURIComponent("" + documentTypeId));
        if (documentTypeLevelType === undefined || documentTypeLevelType === null)
            throw new Error("The parameter 'documentTypeLevelType' must be defined.");
        url_ = url_.replace("{documentTypeLevelType}", encodeURIComponent("" + documentTypeLevelType));
        if (levelId === undefined || levelId === null)
            throw new Error("The parameter 'levelId' must be defined.");
        url_ = url_.replace("{levelId}", encodeURIComponent("" + levelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLabRequestDocumentTypeConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLabRequestDocumentTypeConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComplianceLabRequestDocumentTypeConfigurationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComplianceLabRequestDocumentTypeConfigurationDto>;
        }));
    }

    protected processGetLabRequestDocumentTypeConfiguration(response: HttpResponseBase): Observable<ComplianceLabRequestDocumentTypeConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComplianceLabRequestDocumentTypeConfigurationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCandidateVendorTestCodes(candidateId: number): Observable<CandidateVendorTestCodeDto[]> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/candidate-vendor-test-codes/{candidateId}";
        if (candidateId === undefined || candidateId === null)
            throw new Error("The parameter 'candidateId' must be defined.");
        url_ = url_.replace("{candidateId}", encodeURIComponent("" + candidateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidateVendorTestCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidateVendorTestCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidateVendorTestCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidateVendorTestCodeDto[]>;
        }));
    }

    protected processGetCandidateVendorTestCodes(response: HttpResponseBase): Observable<CandidateVendorTestCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CandidateVendorTestCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addLabRequestDocumentTypeConfiguration(testCodeSetUp: ComplianceLabRequestDocumentTypeConfigurationDto): Observable<void> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/add-lab-request-document-type-configuration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(testCodeSetUp);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddLabRequestDocumentTypeConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddLabRequestDocumentTypeConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddLabRequestDocumentTypeConfiguration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateLabRequestDocumentTypeConfiguration(documentTypeId: number, testCodeSetUp: ComplianceLabRequestDocumentTypeConfigurationDto): Observable<void> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/update-lab-request-document-type-configuration/{documentTypeId}";
        if (documentTypeId === undefined || documentTypeId === null)
            throw new Error("The parameter 'documentTypeId' must be defined.");
        url_ = url_.replace("{documentTypeId}", encodeURIComponent("" + documentTypeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(testCodeSetUp);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLabRequestDocumentTypeConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLabRequestDocumentTypeConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateLabRequestDocumentTypeConfiguration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDsDocumentTypeIds(): Observable<number[]> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/ds-document-type-ids";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDsDocumentTypeIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDsDocumentTypeIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetDsDocumentTypeIds(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLabOtherLookup(): Observable<KeyValueDto[]> {
        let url_ = this.baseUrl + "/ayanova/compliance/compliance-requests/lab-other-lookup";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLabOtherLookup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLabOtherLookup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueDto[]>;
        }));
    }

    protected processGetLabOtherLookup(response: HttpResponseBase): Observable<KeyValueDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KeyValueDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}